import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { FormControl } from '@angular/forms';
import { startWith, map, Observable } from 'rxjs';
import { LetDirective } from '@ngrx/component';
import { TranslatePipe } from '@ngx-translate/core';
import { UiAvatarComponent } from '@ui';
import { AuthenticationService } from '../../../../../authentication/authentication.service';
import { UiSearchComponent } from '../../../../../shared/ui-kit/ui-search/ui-search.component';
import { UiTruncatedHtmlComponent } from '../../../../../shared/ui-kit/ui-truncated-html/ui-truncated-html.component';
import { UserOrganizationDropDown } from '@models/organization.model';
import { smartSearch } from '../../../../../helpers/common.helpers';

@Component({
  selector: 'app-switch-organization-default-search',
  standalone: true,
  imports: [
    AsyncPipe,
    NgForOf,
    NgIf,
    LetDirective,
    TranslatePipe,
    UiSearchComponent,
    UiAvatarComponent,
    UiTruncatedHtmlComponent,
  ],
  templateUrl: './switch-organization-default-search.component.html',
  styleUrl: './switch-organization-default-search.component.scss',
})
export class SwitchOrganizationDefaultSearchComponent implements OnInit, AfterViewInit {
  @Input() userOrganizations: UserOrganizationDropDown[];
  @Output() public readonly onMenuClosed: EventEmitter<void> = new EventEmitter<void>();

  public filteredUserOrganizations$: Observable<UserOrganizationDropDown[]>;

  private readonly searchOrganizationFormControl: FormControl = new FormControl<any>([]);

  @ViewChild('uiSearchComponent') uiSearchComponent: HTMLElement;

  constructor(private readonly authenticationService: AuthenticationService) {}

  public ngOnInit(): void {
    this.filteredUserOrganizations$ = this.searchOrganizationFormControl.valueChanges.pipe(
      startWith(''),
      map(query => smartSearch<UserOrganizationDropDown>(this.userOrganizations, query, 'name')),
    );
  }

  public ngAfterViewInit(): void {
    this.uiSearchComponent?.focus();
  }

  public onSearchOrganizationInput(query: string): void {
    this.searchOrganizationFormControl.patchValue(query);
  }

  public async switchOrg(id: string): Promise<void> {
    this.onMenuClosed.emit();
    await this.authenticationService.switchTenant(id, true);
  }
}
